module.exports = __webpack_public_path__ + "img/join_enterprise.ab52ea77.svg";